module.exports = __webpack_public_path__ + "img/智能移动终端数字化转型场景图谱.8cdba559.jpg";